<button
  type="button"
  class="tw-flex tw-flex-col tw-gap-4 sm:tw-items-center tw-w-full tw-rounded-xl tw-border-0 tw-bg-dt-surface-card tw-p-5 tw-text-left tw-text-base tw-font-semibold tw-text-neutral-800 tw-shadow-card-elevated dark:tw-bg-transparent dark:!tw-shadow-elevation-card md:tw-h-auto md:tw-flex-row-reverse md:tw-justify-between"
  [ngClass]="{ 'tw-opacity-40 !tw-cursor-default': !isEnabled() }"
  [attr.data-testid]="testId() ?? null"
  [disabled]="!isEnabled()"
  (click)="handleClick()"
>
  <ng-content></ng-content>
  <div class="tw-w-full tw-flex tw-flex-col tw-gap-1">
    <span class="tw-font-semibold tw-text-[16px] tw-leading-tight tw-tracking-normal">
      {{ title() }}
    </span>
    @if (description()) {
      <span
        class="tw-text-left tw-text-[14px] tw-font-medium tw-leading-none tw-tracking-normal tw-text-dt-text-tertiary"
        [ngClass]="{ 'tw-h-[34px]': description() }"
      >
        {{ description() }}
      </span>
    }
  </div>
</button>
